/**
 * QuantitySelector - quantity input with increment/decrement controls.
 * Custom element: <quantity-selector>
 *
 * Attributes (from $info):
 *   min    Number  -
 *   max    Number  9999
 *   value  Number  -
 *
 * Refs:
 *   [data-ref="decreaseButton"]  (required)
 *   [data-ref="increaseButton"]  (required)
 *   [data-ref="input"]  (required)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { dist } from "./vendor.js";
import { ThemeComponent } from "./theme.js";
class QuantitySelector extends ThemeComponent {
  constructor() {
    super(...arguments), this._onChange = new dist.SimpleEventDispatcher();
  }
  get value() {
    return this._value;
  }
  set value(newValue) {
    newValue = Math.min(this.max, Math.max(this.min, newValue)), this._value = newValue, this.render(), this._onChange.dispatch(newValue);
  }
  get onChange() {
    return this._onChange.asEvent();
  }
  init() {
    this.$listen(this.increaseButton, "click", () => this.increment()), this.$listen(this.decreaseButton, "click", () => this.decrement()), this.$listen(this.input, "input", () => this.handleInput()), this.$listen(this.input, "keydown", keydownEvent => {
      keydownEvent.key === "Enter" && keydownEvent.preventDefault();
    }), this.render();
  }
  handleInput() {
    this.value = Number(this.input.value) || 0;
  }
  render() {
    this.input.value = this.value.toString();
  }
  increment() {
    this.input.getAttribute("max") && this.value + 1 > Number(this.input.getAttribute("max")) || this.value++;
  }
  decrement() {
    this.value--;
  }
  setMaxQuantity(maxQuantity) {
    this.input.setAttribute("max", maxQuantity);
  }
}
setFunctionName(QuantitySelector, "QuantitySelector");
const propertyTypes = {
  Number
};
QuantitySelector.prototype.$name = "QuantitySelector";
QuantitySelector.prototype.$info = JSON.parse('{"name":"QuantitySelector","meta":{"isLegacy":false,"selector":"quantity-selector"},"props":[{"attr":"min","reflectAttr":false,"propertyKey":"min","propertyType":"Number","propertyTypeName":"Number","propertyTsTypeName":"number"},{"attr":"max","default":9999,"reflectAttr":false,"propertyKey":"max","propertyType":"Number","propertyTypeName":"Number","propertyTsTypeName":"number"},{"attr":"value","reflectAttr":false,"propertyKey":"_value","propertyType":"Number","propertyTypeName":"Number","propertyTsTypeName":"number"}],"refs":[{"selector":"[data-ref=\\"decreaseButton\\"]","required":true,"propertyKey":"decreaseButton","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"},{"selector":"[data-ref=\\"increaseButton\\"]","required":true,"propertyKey":"increaseButton","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"},{"selector":"[data-ref=\\"input\\"]","required":true,"propertyKey":"input","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLInputElement"}]}');
QuantitySelector.prototype.$info.component = QuantitySelector;
for (const prop of QuantitySelector.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("QuantitySelector/QuantitySelector.ts", {
  QuantitySelector: QuantitySelector
}, void 0);